//  Example
//  Import to your js:
//  import Select from '~/js/modules/custom-select';
//  Use on your page
//  const newObjectName = new Select($('#yourSelectId'), 'Default text');
//  second option (default text) is not required
//  add for parent's selectId class ".custom-select"


//  Constructor select fields
export default function Select(selectId, defaultText = '', required = true) {
    // Initialization selectmenu


    //  create custom select
    this.selMenu = selectId.selectmenu({
        appendTo: selectId.parent()
    });

    // default text on select
    selectId[0].parentNode.querySelector('.ui-selectmenu-text').innerHTML = defaultText;

    if(required) {
        //  create fake first option for default empty select
        const fakeElem = document.createElement('option');
        const text = document.createTextNode(defaultText);
        fakeElem.appendChild(text);
        fakeElem.setAttribute('value', '');
        selectId[0].insertBefore(fakeElem, selectId[0].children[0]);
        selectId[0].options.selectedIndex = '0';
    }

    //  display none for first fake element
    selectId[0].nextElementSibling.addEventListener('click', () => {
        for(let i = 0; i < selectId[0].children.length; i++) {

            if(selectId[0].children[i].getAttribute('value') === '') {
                selectId[0].parentNode.querySelector('.ui-menu').children[i].style.display = 'none';
            }
        }
    });

    //  Checked option
    selectId[0].nextElementSibling.nextElementSibling.addEventListener('click', (e) => {
        for(let i = 0; i < selectId[0].children.length; i++) {

            selectId[0].children[i].removeAttribute('checked');

            if(selectId[0].children[i].innerHTML === e.target.innerHTML) {
                selectId[0].children[i].setAttribute('checked', 'checked');
            }
        }
    });
}
